import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid2';

import './Home.css';
import CarouselBanner from '../../components/banner/CarouselBanner';  
import Avatar from '../../components/avatar/Avatar';

const brands: string[] = [
    require('./assets/aastha-logo.webp'),
    require('./assets/ariane.webp'),
    require('./assets/bombay-dyeing-Logo.webp'),
    require('./assets/bohemia-crystal.webp'),
    require('./assets/borgonovo.webp'),
    require('./assets/cristal-d-arques.webp'),
    require('./assets/deco-pride-exclusive.webp'),
    require('./assets/deco-pride-fiesta.webp'),
    require('./assets/deco-pride.webp'),
    require('./assets/devnow-glassware.webp'),
    require('./assets/durofor.webp'),
    require('./assets/f-n-d-crystal-glass.webp'),
    require('./assets/freelance.webp'),
    require('./assets/lemontree-logo.webp'),
    require('./assets/luigi-bormioli.webp'),
    require('./assets/luminarc.webp'),
];

function Home() {
    return (
        <div className='home'>
            <header className='home-header'>
                <CarouselBanner
                    images={[
                        { src: require('./assets/mainBanner1.webp'), link: '/products/tableware' },
                        { src: require('./assets/mainBanner2.webp'), link: '/products/glassware' },
                    ]}
                    duration={5000}
                    showButtons={false}
                />
            </header>
            <div className='home-section categories'>
                <div className='home-categories-heading'>
                    <h1>{t('home.categories.title.0')} <span className='home-categories-heading-italics' >{t('home.categories.title.1')}</span></h1>
                    <h1>{t('home.categories.title.2')} <span className='home-categories-heading-italics'>{t('home.categories.title.3')}</span></h1>
                </div>
                <Grid item size={6}>
                    <Avatar
                        image={require('./assets/category1.webp')}
                        to='/products/glassware'
                        size='xxl'
                        className='home-category-item'
                        title={t('home.categories.1')}
                    />
                    <Avatar
                        image={require('./assets/category2.webp')}
                        to='/products/handicraft'
                        size='xxl'
                        className='home-category-item'
                        title={t('home.categories.2')}
                    />
                    <Avatar
                        image={require('./assets/category3.webp')}
                        to='/products/homedecor'
                        size='xxl'
                        className='home-category-item'
                        title={t('home.categories.3')}
                    />
                    <Avatar
                        image={require('./assets/category4.webp')}
                        to='/products/silverware'
                        size='xxl'
                        className='home-category-item'
                        title={t('home.categories.4')}
                    />
                </Grid>
                <a href='/products' className='home-categories-button' >{t('home.categories.allCategories')}</a>
            </div>
            <div className='mmtc' >
                <Link to={'/contact-us'} >
                    <img className='home-banner' src={require('./assets/mmtcBanner.webp')} />
                </Link>
            </div>
            <div className='home-section brands'>
                <h1>{t('home.brands')}</h1>
                <Grid item size={6}>
                    {brands.map((brand) => (
                        <img className='home-brand-item' src={brand} />
                    ))}
                </Grid>
            </div>
        </div>
    );
}

export default Home;